(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('customer-info-change-status', {
            parent: 'entity',
            url: '/customer-info-change-status',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.customer.customerInfoChangeStatus" | translate }}',
                parent: 'home'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/customer-info-change-status/customer-info-change-status.html',
                    controller: 'CustomerInfoChangeStatusController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('error');
                	$translatePartialLoader.addPart('task');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('CustomerInfoChangeStatus');
                    $translatePartialLoader.addPart('customer-registration');
                    return $translate.refresh();
                }],
                entity: function(){
                	
                }
            }
        })
       
       };
    })();